
import enLang from "./entries/en-US";
import esLang from "./entries/es-ES";
import chLang from "./entries/zh-ZH";
import frLang from "./entries/fr-FR";
import twLang from "./entries/zh-HK";
import miLang from "./entries/mi-MI";
import idLang from "./entries/id-ID";
import hiLang from "./entries/hi-HI";
import ptLang from "./entries/pt-PT";
import afLang from "./entries/af-AF";
import deLang from "./entries/de-DE";
import jaLang from "./entries/ja-JA";
import koLang from "./entries/ko-KO";
import thLang from "./entries/th-TH";
import tlLang from "./entries/tl-TL";
import viLang from "./entries/vi-VI";
import arLang from "./entries/ar-AR";
import ruLang from "./entries/ru-RU";
import fiLang from "./entries/fi-FI";
import itLang from "./entries/it-IT";
import kmLang from './entries/km-KH';
import daLang from './entries/da-DK';
import plLang from './entries/pl-PL';
const AppLocale = {
  en: enLang,
  es: esLang,
  zh: chLang,
  fr: frLang,
  hk: twLang,
  mi: miLang,
  id: idLang,
  hi: hiLang,
  af: afLang,
  ar: arLang,
  de: deLang,
  ja: jaLang,
  ko: koLang,
  th: thLang,
  tl: tlLang,
  vi: viLang,
  pt: ptLang,
  ru: ruLang,
  fi: fiLang,
  it: itLang,
  km: kmLang,
  da: daLang,
  pl: plLang,
};

export default AppLocale;
